import * as isomorphicSessionStorage from 'lib/storage/isomorphicSessionStorage'

const STORAGE_KEY_PREFIX = 'loyalty-tier-progress-snackbar-'

export function getStorageKey(memberId: string) {
  return `${STORAGE_KEY_PREFIX}${memberId}`
}

export function isSnackbarShown(memberId: string): boolean {
  return isomorphicSessionStorage.get(getStorageKey(memberId)) === true
}

export function markSnackbarAsShown(memberId: string): void {
  isomorphicSessionStorage.set(getStorageKey(memberId), true)
}
